// Reusable toggle (switch) control.
//
// Used in ConsentBanner for cookie prefs and in Settings for email prefs.
// Locked toggles render disabled with a lock icon.

import { Lock } from 'lucide-react';

export function Toggle({
  id,
  checked,
  onChange,
  label,
  description,
  disabled = false,
}: {
  id: string;
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
  description: string;
  disabled?: boolean;
}) {
  return (
    <label
      htmlFor={id}
      className={`flex items-start gap-3 ${disabled ? 'cursor-default opacity-70' : 'cursor-pointer'}`}
    >
      {/* Toggle pill */}
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => !disabled && onChange(!checked)}
        className={`mt-0.5 h-4 w-7 flex-none rounded-full border transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-not-allowed ${
          checked ? 'border-primary bg-primary' : 'border-border bg-muted/40'
        }`}
      >
        <span
          className={`block h-3 w-3 translate-x-0.5 rounded-full bg-background shadow transition-transform ${
            checked ? 'translate-x-3.5' : ''
          }`}
        />
      </button>
      <span className="font-mono text-[11px] leading-relaxed text-muted-foreground">
        <span className="font-semibold text-foreground">{label}</span>
        {disabled && <Lock className="ml-1 inline size-3 text-muted-foreground/60" />}
        {' - '}
        {description}
      </span>
    </label>
  );
}
